import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const StorybookEmbed = makeShortcode("StorybookEmbed");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Content TBD`}</p>
    <ul>
      <li parentName="ul">{`Primer Prism explanation`}</li>
    </ul>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--all-scales'
    }]} height="600" mdxType="StorybookEmbed" />
    <h2>{`Gray`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--gray'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Blue`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--blue'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Green`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--green'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Yellow`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--yellow'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Orange`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--orange'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Red`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--red'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Purple`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--purple'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Pink`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--pink'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Coral`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--coral'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`Black`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--black'
    }]} height="360" mdxType="StorybookEmbed" />
    <h2>{`White`}</h2>
    <StorybookEmbed baseUrl="https://primer-caa1ba0fe0-26615723.drafts.github.io/storybook/" stories={[{
      id: 'color-base-scales--white'
    }]} height="360" mdxType="StorybookEmbed" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      